import 'css-chunksrc/client/scenes/workloads/wbs/event/styles.scss';export default {
  "event": "_event_txi2c_1",
  "contextualMenu": "_contextualMenu_txi2c_7",
  "hovered": "_hovered_txi2c_11",
  "icon": "_icon_txi2c_14",
  "eventDetails": "_eventDetails_txi2c_18",
  "name": "_name_txi2c_25",
  "taskAdvancement": "_taskAdvancement_txi2c_44",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_txi2c_50",
  "removeIcon": "_removeIcon_txi2c_63",
  "status": "_status_txi2c_67",
  "allocations": "_allocations_txi2c_74",
  "text": "_text_txi2c_81",
  "tick": "_tick_txi2c_87",
  "late": "_late_txi2c_94",
  "displayContextualMenu": "_displayContextualMenu_txi2c_105",
  "placeholder": "_placeholder_txi2c_109",
  "done": "_done_txi2c_114"
};